import { render, staticRenderFns } from "./memento_codes.vue?vue&type=template&id=0b6bd766&"
import script from "./memento_codes.vue?vue&type=script&lang=js&"
export * from "./memento_codes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports